import { gql } from '@apollo/client';

const GET_ORG_UNITS = gql`
  query GetOrgUnits($ohts: [Int], $character: String, $filter: String, $offset: Int, $limit: Int) {
    mddapOrgUnits(
      ohts: $ohts
      character: $character
      filter: $filter
      offset: $offset
      limit: $limit
    ) {
      Id
      MddapOrganizationId
      Name
      Fei
      Address1
      Address2
      City
      State
      ZipCode
      IsActive
      MddapOrganization {
        Id
        Name
      }
    }
    mddapOrgUnitsCount(ohts: $ohts, character: $character, filter: $filter)
  }
`;

export default GET_ORG_UNITS;
